import Quill from 'quill';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const BlockEmbed: any = Quill.import('blots/block/embed');

export type CollapseBlotValue = {
  title: string;
  bodyHtml: string;
  open?: boolean;
};

export class CollapseBlot extends BlockEmbed {
  static blotName = 'collapse';
  static tagName = 'DETAILS';
  static className = 'ql-collapse';

  static create(value: CollapseBlotValue | string): HTMLElement {
    const node = super.create() as HTMLDetailsElement;
    const data: CollapseBlotValue =
      typeof value === 'string'
        ? { title: value || 'Seção expansível', bodyHtml: '<p><br></p>', open: true }
        : {
            title: value?.title || 'Seção expansível',
            bodyHtml: value?.bodyHtml || '<p><br></p>',
            open: value?.open !== false,
          };

    if (data.open) {
      node.setAttribute('open', '');
    }

    const summary = document.createElement('summary');
    summary.className = 'ql-collapse__summary';

    const chevron = document.createElement('span');
    chevron.className = 'ql-collapse__chevron';
    chevron.setAttribute('aria-hidden', 'true');
    chevron.textContent = '▾';

    const title = document.createElement('span');
    title.className = 'ql-collapse__title';
    title.setAttribute('contenteditable', 'true');
    title.textContent = data.title;

    title.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
    });
    title.addEventListener('mousedown', (event) => {
      event.stopPropagation();
    });
    title.addEventListener('blur', () => {
      if (!title.textContent?.trim()) {
        title.textContent = 'Seção expansível';
      }
    });

    summary.appendChild(chevron);
    summary.appendChild(title);

    const body = document.createElement('div');
    body.className = 'ql-collapse__body';
    body.setAttribute('contenteditable', 'true');
    body.innerHTML = data.bodyHtml;

    node.appendChild(summary);
    node.appendChild(body);

    node.addEventListener('mousedown', (event) => {
      const target = event.target as HTMLElement;
      if (target.closest('.ql-collapse__title') || target.closest('.ql-collapse__body')) {
        event.stopPropagation();
      }
    });

    return node;
  }

  static value(node: HTMLElement): CollapseBlotValue {
    const title = node.querySelector('.ql-collapse__title');
    const body = node.querySelector('.ql-collapse__body');
    return {
      title: title?.textContent?.trim() || 'Seção expansível',
      bodyHtml: body?.innerHTML || '<p><br></p>',
      open: (node as HTMLDetailsElement).open,
    };
  }
}
